import dayjs from "dayjs";

export const formatChartDate = (value: string, granularity: string): string => {
  if (granularity === "month") return dayjs(value).format("MMM YYYY");
  return dayjs(value).format("MMM D");
};

export const toOptions = (values: string[] = []) => values.map(v => ({ label: v, value: v }));

const CAPITALIZED_PRODUCT_NAMES = ["DLT", "SQL"];

export const isAcronym = (word: string): boolean => {
  return word.length >= 2 && word.length <= 4 && word === word.toUpperCase();
};

export const formatTitleCase = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const formatProductName = (product: string): string => {
  return product
    .split("_")
    .map(word => {
      if (isAcronym(word) || CAPITALIZED_PRODUCT_NAMES.includes(word.toUpperCase())) {
        return word.toUpperCase();
      }
      return formatTitleCase(word);
    })
    .join(" ");
};

export const formatDuration = (ms: number): string => {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  if (ms < 3600000) return `${(ms / 60000).toFixed(1)}m`;
  return `${(ms / 3600000).toFixed(1)}h`;
};

export const formatSuccessRate = (successful: number, total: number) => {
  if (total === 0) return "N/A";
  const rate = (successful / total) * 100;
  return `${rate.toFixed(2)}%`;
};

export const getSuccessRateBadgeColor = (successful: number, total: number) => {
  if (total === 0) return "!al-bg-gray-100 !al-text-gray-600";
  const rate = successful / total;
  if (rate >= 0.95) return "!al-bg-green-100 !al-text-green-700";
  if (rate >= 0.8) return "!al-bg-yellow-100 !al-text-yellow-700";
  return "!al-bg-red-100 !al-text-red-700";
};
